import {
  MonthlyAndDailyResponseData,
  CountingResponseData,
} from '@/types/api/chargingPile/getChargingPileExpenseList';
import type { TableColumnsType } from 'antd';

function getSorter(
  key: keyof CountingResponseData | keyof MonthlyAndDailyResponseData
) {
  return (
    a: CountingResponseData | MonthlyAndDailyResponseData,
    b: CountingResponseData | MonthlyAndDailyResponseData
  ) => {
    if (typeof a[key] === 'string') {
      return a[key].localeCompare(b[key]);
    }
    return a[key] - b[key];
  };
}
// 依每日用量columns
// 電錶ID、住戶門牌、車位編號、日期、度數、充電樁電費（元）
export const monthlyAndDailyColumns: TableColumnsType<
  MonthlyAndDailyResponseData & {
    key: string;
  }
> = [
  {
    title: '電錶ID',
    dataIndex: 'chargingPileID',
    sorter: getSorter('chargingPileID'),
  },
  {
    title: '住戶門牌',
    dataIndex: 'householdNumber',
    sorter: getSorter('householdNumber'),
  },
  {
    title: '車位編號',
    dataIndex: 'parkingNumber',
    sorter: getSorter('parkingNumber'),
  },
  { title: '日期', dataIndex: 'date', sorter: getSorter('date') },
  {
    title: '起始度數',
    dataIndex: 'startEnergy',
    sorter: getSorter('startEnergy'),
  },
  { title: '結束度數', dataIndex: 'endEnergy', sorter: getSorter('endEnergy') },
  { title: '用電度數', dataIndex: 'usage', sorter: getSorter('usage') },
  {
    title: '充電樁電費（元）',
    dataIndex: 'expense',
    sorter: getSorter('expense'),
  },
];

// 依每次用量columns
// 電錶ID、住戶門牌、車位編號、起始時間、結束時間、充電時程、度數、計價標準、計價單價	充電樁電費(元)
export const countingColumns: TableColumnsType<
  CountingResponseData & {
    key: string;
  }
> = [
  {
    title: '電錶ID',
    dataIndex: 'chargingPileID',
    sorter: getSorter('chargingPileID'),
  },
  {
    title: '住戶門牌',
    dataIndex: 'householdNumber',
    sorter: getSorter('householdNumber'),
  },
  {
    title: '車位編號',
    dataIndex: 'parkingNumber',
    sorter: getSorter('parkingNumber'),
  },
  {
    title: '起始時間',
    dataIndex: 'startTime',
    sorter: getSorter('startTime'),
  },
  {
    title: '結束時間',
    dataIndex: 'endTime',
    sorter: getSorter('endTime'),
  },
  {
    title: '充電時程',
    dataIndex: 'chargingTime',
    sorter: getSorter('chargingTime'),
    render: (value) => {
      if (value) {
        const hours = Math.floor(value / 60);
        const hourLabel = hours > 0 ? `${hours}小時` : '';
        const minutes = value % 60;
        return `${hourLabel}${minutes}分鐘`;
      }
      return '';
    },
  },
  {
    title: '起始度數',
    dataIndex: 'startEnergy',
    sorter: getSorter('startEnergy'),
  },
  { title: '結束度數', dataIndex: 'endEnergy', sorter: getSorter('endEnergy') },
  {
    title: '用電度數',
    dataIndex: 'usage',
    sorter: getSorter('usage'),
  },
  {
    title: '計價標準',
    dataIndex: 'pricingStandard',
  },
  {
    title: '計價單價(元/度)',
    dataIndex: 'pricingUnitPrice',
  },
  {
    title: '充電樁電費(元)',
    dataIndex: 'expense',
    sorter: getSorter('expense'),
  },
];

export type CountingColumnsType = TableColumnsType<
  CountingResponseData & { key: string }
>;
export type MonthlyAndDailyColumnsType = TableColumnsType<
  MonthlyAndDailyResponseData & { key: string }
>;

export type ActionColumnType = {
  title: string;
  dataIndex: string;
  fixed: 'left' | 'right';
  render: (
    _: any,
    record:
      | (CountingResponseData & { key: string })
      | (MonthlyAndDailyResponseData & { key: string })
  ) => void;
};
